import { jsx as _jsx } from "react/jsx-runtime";
import theme from '../../Theming/DefaultTheme';
import { Box, Typography } from '@mui/material';
var chipStyles = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.tertiary.dark,
    color: theme.palette.primary.contrastText,
    padding: '8px 10px',
    minWidth: 130,
    borderRadius: 8,
    boxShadow: '0px 0px 5px rgba(0,0,0,0.2)',
};
var MapUserChip = function (_a) {
    var user = _a.user;
    return (_jsx(Box, { style: chipStyles, children: _jsx(Typography, { variant: 'body2', children: "user-".concat(user.userId) }) }));
};
export default MapUserChip;
